import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://procode-3f64a.firebaseio.com/'
});

export default instance;


// WEBPACK FOOTER //
// ./src/axios-instance.js